import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { ShaftByShaftNameForDropdown } from '../../api/models';

export type TABLE_TYPE = Table<ShaftByShaftNameForDropdown>;

export const TABLE = 'hybridShaftByShaftNameForDropdown';
const SCHEMA = 'id, name';

class HybridShaftByShaftNameForDropdownDatabase implements DataRepository<ShaftByShaftNameForDropdown> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<ShaftByShaftNameForDropdown | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: ShaftByShaftNameForDropdown, key: Key): Promise<ShaftByShaftNameForDropdown> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: ShaftByShaftNameForDropdown[]): Promise<ShaftByShaftNameForDropdown[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<ShaftByShaftNameForDropdown[]> {
    return this.db[TABLE].orderBy('name').toArray();
  }
}

export const HybridShaftByShaftNameForDropdownDB = new HybridShaftByShaftNameForDropdownDatabase(db);
